// Importing a utility function for class name concatenation
import { cn } from '../../lib/utils';

// Define the interface for the `Card` component's props
interface CardProps {
  children: React.ReactNode; // The content to be rendered inside the card
  className?: string;        // Optional additional class names for customization
}

// Functional component for rendering a reusable card
export function Card({ children, className }: CardProps) {
  return (
    <div
      // Use the `cn` utility to concatenate default and custom class names
      className={cn(
        "bg-white rounded-xl shadow-lg p-6 sm:p-8", // Default styles for the card
        "border border-gray-100",                  // Light border for separation
        "transition-shadow duration-200 hover:shadow-xl", // Smooth shadow effect on hover
        className                                   // Allow additional styles via the `className` prop
      )}
    >
      {/* Render the children (content passed to the card) */}
      {children}
    </div>
  );
}
